var map = {
	"./+barrel": [
		"spIJ",
		3
	],
	"./+child-barrel": [
		"5jMu",
		4
	],
	"./+child-detail": [
		"JbPC",
		2
	],
	"./+detail": [
		"icz3",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "SfPD";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./$$_lazy_route_resource lazy
// module id = SfPD
// module chunks = 6